import type { WorkspaceExport } from '@/api/workspaceExport/workspaceExportApi.types';
import {
  WORKSPACE_EXPORT_POLL_INTERVAL_MILLISECONDS,
  WORKSPACE_EXPORT_STATUS,
} from '@/constants/workspaceData';

export function isWorkspaceExportInProgress(workspaceExport: WorkspaceExport | null): boolean {
  if (workspaceExport === null) {
    return false;
  }
  return (
    workspaceExport.status === WORKSPACE_EXPORT_STATUS.pending ||
    workspaceExport.status === WORKSPACE_EXPORT_STATUS.building
  );
}

export function resolveWorkspaceExportPollingInterval(
  workspaceExport: WorkspaceExport | null | undefined
): number | false {
  if (workspaceExport === undefined) {
    return false;
  }
  return isWorkspaceExportInProgress(workspaceExport)
    ? WORKSPACE_EXPORT_POLL_INTERVAL_MILLISECONDS
    : false;
}
